module.exports = __webpack_public_path__ + "static/TiemposText-Regular-1fa94096b5e8b5595d4b9cdc81a162de.woff";